export const CALENDAR_TYPES = {
	GREGORY: 'gregory',
	HEBREW: 'hebrew',
	ISLAMIC: 'islamic',
	ISO_8601: 'iso8601',
} as const;

export const CALENDAR_TYPE_LOCALES = {
	[CALENDAR_TYPES.GREGORY]: [
		'en-CA',
		'en-US',
		'es-AR',
		'es-BO',
		'es-CL',
		'es-CO',
		'es-CR',
		'es-DO',
		'es-EC',
		'es-GT',
		'es-HN',
		'es-MX',
		'es-NI',
		'es-PA',
		'es-PE',
		'es-PR',
		'es-SV',
		'es-VE',
		'pt-BR',
	],
	[CALENDAR_TYPES.HEBREW]: ['he', 'he-IL'],
	[CALENDAR_TYPES.ISLAMIC]: [
		// ar-LB, ar-MA intentionally missing
		'ar',
		'ar-AE',
		'ar-BH',
		'ar-DZ',
		'ar-EG',
		'ar-IQ',
		'ar-JO',
		'ar-KW',
		'ar-LY',
		'ar-OM',
		'ar-QA',
		'ar-SA',
		'ar-SD',
		'ar-SY',
		'ar-YE',
		'dv',
		'dv-MV',
		'ps',
		'ps-AR',
	],
};

export const LOCALE_CALENDAR_TYPES = Object.fromEntries(
	Object.entries(CALENDAR_TYPE_LOCALES).flatMap(([k, v]) => v.map(v => [v, k]))
);

export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6] as const;
